import { render, staticRenderFns } from "./GroupMember.vue?vue&type=template&id=c888ef3a&scoped=true&lang=pug&"
import script from "./GroupMember.vue?vue&type=script&lang=js&"
export * from "./GroupMember.vue?vue&type=script&lang=js&"
import style0 from "./GroupMember.vue?vue&type=style&index=0&id=c888ef3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c888ef3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/Kou/projects/vue-projects/joseph/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
